module.exports = __webpack_public_path__ + "img/car-turret.9c30f0e8.png";